import React ,{useEffect, useState}  from "react";
import { Redirect } from 'react-router';
import firebase from "./Config";
import swal from 'sweetalert';

const Create = (props) =>{

    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [cover, setCover] = useState(""); 

    const [isBusy, setIsBusy] = useState(false);
    const [routeRedirect, setRedirect] = useState(false);   

    const addPost = async(e) => {
        e.preventDefault();
        setIsBusy(true);

        let post = {
            title, 
            content,
            cover: cover[0]
        }

        await firebase.createPost(post).then(() => {
            swal("Good job!", "Your Post Created!", "success");
            setIsBusy(false);
            setRedirect(true);
        
        }).catch(err => {
            swal("permission denied","not right user","warning");
            console.log(err);
            setIsBusy(false);
        })        

        }

    useEffect(() => {
        firebase.getUserState().then(user => {
            if(!user){
                window.location.replace("/");
            }
          
        })
    })    

    const redirect = routeRedirect;
    if(redirect){
        return <Redirect to="/" />  
    }


    let createForm;
    if(isBusy){
        createForm =  <div className="text-center">
        <div class="spinner-border text-primary" style={{width: "13rem", height: "13rem"}} role="status">
        <span class="sr-only">Loading...</span>
       </div></div>  
    }else{
        createForm =    <>
    <div class="page-title-overlap bg-dark pt-4">
      <div class="container d-lg-flex justify-content-between py-2 py-lg-3">
        <div class="order-lg-2 mb-3 mb-lg-0 pt-lg-2">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-light flex-lg-nowrap justify-content-center justify-content-lg-start">
              <li class="breadcrumb-item"><a class="text-nowrap" href="/"><i class="czi-home"></i>Home</a></li>
              <li class="breadcrumb-item text-nowrap"><a href="#">Create Post</a>
              </li>
              <li class="breadcrumb-item text-nowrap active" aria-current="page">Create Post</li>
            </ol>
          </nav>
        </div>
        <div class="order-lg-1 pr-lg-4 text-center text-lg-left">
          <h1 class="h3 text-light mb-0">Admin Post Area</h1>
        </div>
      </div>
    </div>
    <div class="container py-4 py-lg-5 my-4">
      <div class="row">
         
        <div class="col-md-12 ">
          <div class="card border-0 box-shadow " >
                       <form onSubmit={addPost} style={{margin:"65px"}} className=" needs-validatio">
                        <p>Create a new post</p>
                        
                        <label htmlFor="title">Post Title: </label>
                        <div className="text-center">
                        <input type="text" className="form-control"  name="title" onChange={(e) => setTitle(e.target.value)} />
                        </div>
                        <label htmlFor="content">Post Content: </label>
                        <textarea name="content" className="form-control" rows="10" cols="12" onChange={(e) => setContent(e.target.value)}  ></textarea>
                    
                        <label htmlFor="cover" className="cover">Image Size (600x350)</label>
                        <input type="file" className="form-control" onChange={(e) => setCover(e.target.files)} /><br></br>

                        <label htmlFor="cover" className="cover"> Submit</label><br></br>
                        <input type="submit" className="btn btn-primary btn-shadow" value="create post" />
                    </form>
                    </div>
                 
                    </div>
                    </div>
                    </div>
                    </>

    }


    return(
        <React.Fragment>
            {createForm}
        </React.Fragment>
    )


}
export default Create;